import React, { FC } from 'react'
import { filter } from 'lodash'
import {
    FormSelect,
    FormSelectProps,
} from '@docpace/shared-react-components/FormSelect'
import { TranslationFragment } from '@docpace/shared-graphql/fragments'
import { useFormContext, useWatch } from 'react-hook-form'
import { TranslationType } from '@docpace/shared-ts-types'

interface MuiFormTranslationSelectProps extends Omit<FormSelectProps, 'options'> {
    formController?: any
    translations: TranslationFragment[]
    translationType: TranslationType
    label?: string
}

export const MuiFormTranslationSelect: FC<MuiFormTranslationSelectProps> = ({
    formController,
    translations,
    translationType,
    ...selectProps
}) => {
    const { name, defaultValue } = selectProps
    const formContext = useFormContext()
    const {
        control,
        formState: { errors },
    } = formContext
    return (
        <FormSelect {...selectProps} options={[
            { value: '', label: 'none' },
            ...translations?.length > 0 ? translations?.map(translation=>({
                label: translation?.name,
                value: translation?.translationId
            })): []
        ]} />
    )
}

export default MuiFormTranslationSelect
